import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ConnectionService } from '../../services/connection.service';
import { DataFieldsService } from '../../services/data-fields.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-hdfc-proposal-form',
  templateUrl: './hdfc-proposal-form.page.html',
  styleUrls: ['./hdfc-proposal-form.page.scss'],
})
export class HdfcProposalFormPage implements OnInit {
  occupationList: any = [];
  occupation: any = [];
  occupationCategory: any = [];
  occupationDesignation: any = [];
  indusTypeList: any = [];
  country: any = [];
  hdfcSalutation: any = [];
  hdfcMartialStatus: any = [];
  ckycValue: any = [];
  ckycForm: FormGroup;
  hdfcLifeAssuredDetailsForm: FormGroup;
  nomineDetailForm: FormGroup;
  appointeeDetailsForm: FormGroup;
  showHdfcCkyc: boolean = false;
  showSpouseField: boolean = true;
  lifeAssuredFilled: any = "section-btn active-section-btn";
  nominee: any = "section-btn"
  appointee: any = "section-btn"
  disableFormSegmentBtns: boolean = true;
  showLifeAssured: boolean = true;
  showNominee: boolean = false;
  showAppointee: boolean = false;
  sameCurrentAddr: boolean = true;
  showNominee2: boolean = false;
  hideNomineAddbtn: boolean = true;
  hideNomineRemoveBtn: boolean = false;
  percentageNominee: boolean;
  hdfcGender: any = [];
  nationality: any = [];
  educationQualification: any = [];
  residenseStatus: any = [];
  hdfcBirthPlace: any = [];
  addressType: any = [];
  hdfcStateList: any = [];
  hdfcCountry: any = [];
  hdfcContact: any = [];
  hdfcSourceFund: any = [];
  hdfcRelation: any = [];
  hdfcAppntRelWithNom: any = [];
  appObj: any = [];
  disablepr_DOB: boolean = true;
  sumPercentage: any;
  quoteTempid: any;
  orderTempId: any;
  appTempno: any;
  uwTemptype: any;
  appBasicReqData = {
    quoteid: 0,
    orderId: 0,
    quotedt: this._datePipe.transform(new Date(), 'dd/MM/yyyy'),
    appno: '',
    totPremium: '',
    paymentFreq:'',
    prodCode: "P1C2PLE",
    apptype: 'APP_TYP_LIFE',
    appmode: 'APP_MODE_NON_ASST',
    appsource: 'OL',
    chnlpartner: 'ONLINE',
    instype: '',
    insobjectv: 'IOBJ_PROTN_CD',
    uwtype: '',
    payoutNeftFlag: 'N',
    appstatus: 'APP005',
    proposalrecvdt: this._datePipe.transform(new Date(), 'dd/MM/yyyy'),
    magNumBenefit: "Life",
    countrycode: "91",
    expdurofstay: "MTH1YR",
    preferredCommAddr: "ADD_CORSP",
    preferredCommMode: "CALL",
    preferredCommLang: "LANG_ENG",
    productPlanOption: "",
  }
  applicationOrderId: any;

  quoteFormReqObj: any;
  userObj: any;
  upgradedQuoteReqObj: any;
  upgradedQuoteResponseObj: any;
  appIncompleteData: any;
  monthlyFreq: any;
  disableAddNomineeBtn: boolean = false;

  constructor(
    private _data: DataFieldsService, private fb: FormBuilder,
    private apiService: ConnectionService,
    private toast: ToastService,
    private _datePipe: DatePipe,
    private strg: StorageService,
    private loader: LoaderService,
    private router: Router
  ) {

  }

  ionViewDidEnter(){
    this.strg.getStoreData("quoteFormData").then(res => {
      this.quoteFormReqObj = res;
      console.log("quoteFormReqObj", this.quoteFormReqObj);
    });

    this.strg.getStoreData("userObj").then(res => {
      this.userObj = res;
      this.strg.getStoreData("incp").then(ress => {
        console.log("mmmmm", ress)
        if (ress === true) {
          console.log("incomplete");
          this.strg.getStoreData('hdfcRedirectUrl').then(resss =>{
            if(resss){
              this.strg.getStoreData('hdfcBasicReqData').then(ressss =>{
                this.appBasicReqData = ressss
                this.showHdfcCkyc = true;
                this.strg.getStoreData('hdfcCkycFormData').then(ele =>{
                  this.ckycForm.setValue(ele);
                })
              })
            } else {
              this.getIncompleteApplication();
            }
          })
        } else {
          console.log("complete");
          // this.getAppOrderId();
          this.getQuoteResId();
        }
      })
    })
  }

  get getNomineeArray() {
    return this.nomineDetailForm.get('nomineeArray') as FormArray;
  }

  get geAppointeeArray() {
    return this.appointeeDetailsForm.get('appointeeArray') as FormArray;
  }

  addNominee() {
    if(this.getNomineeArray.length === 2){
      this.toast.showToast("You can add only 2 Nominees");
    } else{
      let sharePer = 0;
      this.getNomineeArray.value.forEach(ele => { sharePer += Number(ele.entitlePercentage) });
      if(sharePer >= 100){
        this.toast.showToast("Entitlement Percentage is already 100");
      }else {
        this.getNomineeArray.push(this.fb.group({
          partySeqId: ['NOMINEE_1'],
          relatedParty: ['LA_0'],
          title: ['', [Validators.required]],
          firstName: ['', [Validators.required]],
          lastName: ['', [Validators.required]],
          gender: ['', [Validators.required]],
          dob: ['', [Validators.required]],
          maritalStatus: ['', [Validators.required]],
          entitlePercentage: ['', [Validators.required, Validators.min(1), Validators.max(100)]],
          houseNo: ['', [Validators.required]],
          street: ['', [Validators.required]],
          city: ['', [Validators.required]],
          state: ['', [Validators.required]],
          landMark: ['', [Validators.required]],
          pinCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
          country: ['', [Validators.required]],
          relationship: ['', [Validators.required]],
          // hdfc_nCtype:['',[Validators.required]],
          // hdfc_nContNo: ['', [Validators.required]],
        }));
      }
    }
    console.log("ffff", this.getNomineeArray.length);
  }

  addAppointee() {
    this.geAppointeeArray.push(this.fb.group({
      partySeqId: ['APPOINTEE_1'],
      title: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      maritalStatus: ['', [Validators.required]],
      houseNo: ['', [Validators.required]],
      street: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      landMark: ['', [Validators.required]],
      pinCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      country: ['', [Validators.required]],
      relatedParty:[''],
      relationship: ['', [Validators.required]],
    }));
  }

  removeNominee(index) {
    this.getNomineeArray.removeAt(index);
  }

  removeAppointee(index) {
    this.geAppointeeArray.removeAt(index);
  }

  ngOnInit() {
    this.occupationList = this._data.getHdfcOccupationList();
    this.occupation = this._data.getHdfcOccupation();
    this.occupationCategory = this._data.getHdfcOccupationCategory();
    this.occupationDesignation = this._data.getHdfcOccpationDesignation();
    this.indusTypeList = this._data.getHdfcIndustryTypeList();
    this.country = this._data.getCountry();
    this.hdfcSalutation = this._data.getHdfcSalutation();
    this.hdfcMartialStatus = this._data.getHdfcMaritalStatus();
    this.hdfcGender = this._data.getHdfcGender();
    this.educationQualification = this._data.gethdfcEducationQualification();
    this.nationality = this._data.gethdfcNationality();
    this.residenseStatus = this._data.gethdfcResidenceStatus();
    this.hdfcBirthPlace = this._data.gethdfcBirthPlace().sort((a: any, b: any) => (a.label > b.label ? 1 : -1));
    this.addressType = this._data.gethdfcAddressType();
    this.hdfcStateList = this._data.getHdfcState();
    this.hdfcCountry = this._data.getHdfcCountry();
    this.hdfcContact = this._data.getHdfcContact();
    this.hdfcSourceFund = this._data.getHdfcSource();
    this.hdfcRelation = this._data.getHdfcRelationShip();
    this.hdfcAppntRelWithNom = this._data.getHdfcAppointeeRelWithNom();
    this.ckycForm = this.fb.group({
      fatherCkycDetails: ['', [Validators.required]],
      ckyc_fatherFrstNm: ['', [Validators.required]],
      ckyc_fatherMiddleNm: [],
      ckyc_fatherLastNm: ['', [Validators.required]],
      motherCkycDetails: ['', [Validators.required]],
      ckyc_motherFirstNm: ['', [Validators.required]],
      ckyc_motherMiddleNm: [],
      ckyc_motherLastNm: ['', [Validators.required]],
      ckyc_mrtlSts: ['', [Validators.required]],
      spouseCkycDetails: [''],
      ckyc_SpouseFirstNm: [''],
      ckyc_SpouseMiddleNm: [],
      ckyc_SpouseLastNm: [''],
      ckyc_Occupation: ['', [Validators.required]],
      ckyc_OccupCategory: ['', [Validators.required]],
      ckyc_CountryBirth: ['', [Validators.required]]
    })

    this.hdfcLifeAssuredDetailsForm = this.fb.group({
      hdfc_title: ['', [Validators.required]],
      hdfc_fName: ['', [Validators.required]],
      hdfc_lName: ['', [Validators.required]],
      hdfc_gender: ['', [Validators.required]],
      hdfc_dob: ['', [Validators.required]],
      hdfc_fatherName: ['', [Validators.required]],
      hdfc_MartlStus: ['', [Validators.required]],
      hdfc_spouseNm: [null],
      hdfc_eduQual: ['', [Validators.required]],
      hdfc_nationality: ['', [Validators.required]],
      hdfc_resisStatus: ['', [Validators.required]],
      hdfc_birthPlace: ['', [Validators.required]],
      hdfc_nriFlg: [false],
      hdfc_hdfcEmp: [false, Validators.required],
      hdfc_existCustomer: [false],
      hdfc_ipsaca: [false],
      hdfc_phyDisabled: [false, Validators.required],
      hdfc_pepFlag: [false, Validators.required],
      hdfc_aySmoker: [false, Validators.required],
      hdfc_dmatFlag: [false, Validators.required],
      hdfc_eiaAccNo: [null],
      hdfc_ayConvict: [false, Validators.required],
      hdfc_houseNo: ['', [Validators.required]],
      hdfc_street: ['', [Validators.required]],
      hdfc_landMark: ['', [Validators.required]],
      hdfc_city: ['', [Validators.required]],
      hdfc_state: ['', [Validators.required]],
      hdfc_pinCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      hdfc_country: ['', [Validators.required]],
      hdfc_pHouseNo: [''],
      hdfc_pStreet: [''],
      hdfc_plandMark: [''],
      hdfc_pCity: [''],
      hdfc_pState: [''],
      hdfc_pPincode: [''],
      hdfc_pCountry: [''],
      hdfc_contNumber: ['', [Validators.required]],
      hdfc_email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
      hdfc_occType: ['', [Validators.required]],
      // hdfc_occDesig: [''],
      hdfc_indusType: ['', [Validators.required]],
      hdfc_empName: ['', [Validators.required]],
      hdfc_annIncome: ['', [Validators.required]],
      hdfc_occList: ['', [Validators.required]],
      hdfc_empAddrLine: [''],//Conditional validation
      hdfc_sourceType: ['', [Validators.required]],//Conditional Validation
      hdfc_fundPercentage: ['', [Validators.required]],//Conditional Validation
    })
    
    this.nomineDetailForm = this.fb.group({
      nomineeArray: this.fb.array([
        this.fb.group({
          partySeqId: ['NOMINEE_0'],
          relatedParty: ['LA_0'],
          title: ['', [Validators.required]],
          firstName: ['', [Validators.required]],
          lastName: ['', [Validators.required]],
          gender: ['', [Validators.required]],
          dob: ['', [Validators.required]],
          maritalStatus: ['', [Validators.required]],
          entitlePercentage: ['', [Validators.required, Validators.min(1), Validators.max(100)]],
          houseNo: ['', [Validators.required]],
          street: ['', [Validators.required]],
          city: ['', [Validators.required]],
          state: ['', [Validators.required]],
          landMark: ['', [Validators.required]],
          pinCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
          country: ['', [Validators.required]],
          relationship: ['', [Validators.required]],
          // hdfc_nCtype:['',[Validators.required]],
          // hdfc_nContNo: ['', [Validators.required]],
        })
      ]),
    })

    this.appointeeDetailsForm = this.fb.group({
      appointeeArray: this.fb.array([
        this.fb.group({
          partySeqId: ['APPOINTEE_0'],
          title: ['', [Validators.required]],
          firstName: ['', [Validators.required]],
          lastName: ['', [Validators.required]],
          gender: ['', [Validators.required]],
          dob: ['', [Validators.required]],
          maritalStatus: ['', [Validators.required]],
          houseNo: ['', [Validators.required]],
          street: ['', [Validators.required]],
          city: ['', [Validators.required]],
          state: ['', [Validators.required]],
          landMark: ['', [Validators.required]],
          pinCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
          country: ['', [Validators.required]],
          relatedParty:[''],
          relationship: ['', [Validators.required]],
        })
      ]),
    })
    // this.getQuoteResId()
  }
  
  // ionViewDidEnter() {
  // }

  getIncompleteApplication() {
    this.loader.showLoader();
    this.apiService.getIncompleteICICIAppData().subscribe(res => {
      this.loader.hideLoader();
      console.log("ffffffffff1", res)
      if (res) {
        if (res.data.length != 0) {
          console.log("appINcompe", res);
          // let data = res.data.reverse();
          let data = res.data;
          data = data[0];
          console.log("ffffffffff2", data)
          this.upgradedQuoteResponseObj = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam);
          this.upgradedQuoteReqObj = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.reqParam);
          console.log("ffffffffff3", this.upgradedQuoteResponseObj, this.upgradedQuoteResponseObj.id)
          // if(this.upgradedQuoteResponseObj.modeOfPayment === "Monthly") {
          //   this.monthlyFreq = true;
          // } else {
          //   this.monthlyFreq = false;
          // }

          // this.createProductPlanOption();

          this.appBasicReqData.orderId = data.insuranceOrderHistory.id;
          this.applicationOrderId = data.insuranceOrderHistory.id;
          // this.appBasicReqData.quoteid = this.upgradedQuoteResponseObj.quoteid;
          this.appBasicReqData.quoteid = data.insuranceOrderHistory.insuranceQuoteResponse.id;
          this.appBasicReqData.paymentFreq = this.upgradedQuoteReqObj.freq;
          this.appBasicReqData.quotedt = this._datePipe.transform(this.upgradedQuoteResponseObj.qtDt, "dd/MM/yyyy");
          this.appBasicReqData.appno = this.upgradedQuoteResponseObj.appnum;
          this.appBasicReqData.totPremium = this.upgradedQuoteResponseObj.totPremium;
          // this.appBasicReqData.paymentFreq = this.upgradedQuoteResponseObj.freq;
          // this.appBasicReqData.prodCode = this.upgradedQuoteResponseObj.prodCode; //commented prodcode for static value
          // this.appBasicReqData.appmode = this.upgradedQuoteResponseObj.appMode; //commented appmode for static value
          this.appIncompleteData = JSON.parse(data.parameter);
          console.log("incomplete data details", this.appIncompleteData);
          this.autoFillFormData(this.appIncompleteData);
          this.createProductPlanOption();
        } else {
          // this.getAppOrderId();
          this.getQuoteResId();
        }
      }
    }, err => {
      this.loader.hideLoader();
      console.log("error", err);
    });
  }

  riderDetails: any = [];

  createProductPlanOption(){
    this.riderDetails = [];
    let productPlanOption = "";
    let productPlanSubOption = "";
    let productPlanPremiumFreq = "";
    console.log("upgraded quote req data", this.upgradedQuoteReqObj);
    console.log("upgraded quote res data", this.upgradedQuoteResponseObj);
    let riderObj;
    if(this.upgradedQuoteResponseObj.rider){
      this.upgradedQuoteResponseObj.rider.forEach(item => {
        if(item.name === "C4CI"){
          riderObj = {
            "riderName": "RIDER_CRITICAL_ILLNESS",
            "riderSumAssured": String(item.sumAssured),
            "riderTerm": String(item.term),
            "riderPPT": String(item.ppt),
            "riderPremiumAmount": String(item.premium + item.tax)
          }
          this.riderDetails.push(riderObj);
        }
        if(item.name === "PPR_CC"){
          riderObj = {
            "riderName": "RIDER_CANCER_COVER",
            "riderSumAssured": String(item.sumAssured),
            "riderTerm": String(item.term),
            "riderPPT": String(item.ppt),
            "riderPremiumAmount": String(item.premium + item.tax)
          }
          this.riderDetails.push(riderObj);
        }
        if(item.name === "INAD"){
          riderObj = {
            "riderName": "RIDER_INCOME_BENEFIT",
            "riderSumAssured": String(item.sumAssured),
            "riderTerm": String(item.term),
            "riderPPT": String(item.ppt),
            "riderPremiumAmount": String(item.premium + item.tax)
          }
          this.riderDetails.push(riderObj);
        }
        if(item.name === "PPR_ADC"){
          riderObj = {
            "riderName": "RIDER_ACCIDENTAL_DEATH_COVER",
            "riderSumAssured": String(item.sumAssured),
            "riderTerm": String(item.term),
            "riderPPT": String(item.ppt),
            "riderPremiumAmount": String(item.premium + item.tax)
          }
          this.riderDetails.push(riderObj);
        }
        if(item.name === "PPR_PAC"){
          riderObj = {
            "riderName": "RIDER_PERSONAL_ACCIDENT_COVER",
            "riderSumAssured": String(item.sumAssured),
            "riderTerm": String(item.term),
            "riderPPT": String(item.ppt),
            "riderPremiumAmount": String(item.premium + item.tax)
          }
          this.riderDetails.push(riderObj);
        }
      })
    } else{
      this.riderDetails = null;
    }
    if(this.upgradedQuoteReqObj.productOption === "Life Protect"){
      productPlanOption = "Life_Protect_";
    } else if(this.upgradedQuoteReqObj.productOption === "Income Plus"){
      productPlanOption = "Income_Plus_";
    } else if(this.upgradedQuoteReqObj.productOption === "Life CI Rebalance"){
      productPlanOption = "Life_CI_Rebalance_";
    }

    if(this.upgradedQuoteReqObj.subOption === "Fixed Term"){
      productPlanSubOption = "Fixed_Term_"
    } else if(this.upgradedQuoteReqObj.subOption === "Whole Life"){
      productPlanSubOption = "Whole_Life_"
    }

    if(this.upgradedQuoteReqObj.premiumPayingTermOption === "REGULAR"){
      productPlanPremiumFreq = "RP"
    } else if(this.upgradedQuoteReqObj.premiumPayingTermOption === "LIMITED"){
      productPlanPremiumFreq = "LP"
    } else if(this.upgradedQuoteReqObj.premiumPayingTermOption === "SINGLE"){
      productPlanPremiumFreq = "SP"
    }

    if(this.upgradedQuoteReqObj.productOption === "Life CI Rebalance"){
      this.appBasicReqData.productPlanOption = productPlanOption+productPlanPremiumFreq
    } else {
      this.appBasicReqData.productPlanOption = productPlanOption+productPlanSubOption+productPlanPremiumFreq
    }
    console.log("Product Plan Option", this.appBasicReqData.productPlanOption);
  }

  autoFillFormData(autoFillData) {
    if(autoFillData.lifeAssuredDetails){
      this.hdfcLifeAssuredDetailsForm.setValue(autoFillData.lifeAssuredDetails);
      this.isPermanentSame();
    }
    if(autoFillData.nomineeDetails){
      console.log("lllll", autoFillData.nomineeDetails.nomineeArray.length)
      autoFillData.nomineeDetails.nomineeArray.forEach(item => {
        console.log("ffff", item)
        if(item.dob){
          let spltDob = item.dob.split("/");
          item.dob = spltDob[2]+"-"+spltDob[1]+"-"+spltDob[0];
          console.log("ffff", item.dob)
        }
      })
      if(autoFillData.nomineeDetails.nomineeArray.length == 2){
        this.addNominee();
        this.getNomineeArray.setValue(autoFillData.nomineeDetails.nomineeArray);
        this.dobValidate(autoFillData.nomineeDetails.nomineeArray[0].dob, 1);
        this.dobValidate(autoFillData.nomineeDetails.nomineeArray[1].dob, 2);
      } else {
        this.getNomineeArray.setValue(autoFillData.nomineeDetails.nomineeArray);
        this.dobValidate(autoFillData.nomineeDetails.nomineeArray[0].dob, 1);
      }
    }
    if(autoFillData.appointeeDetails){
      autoFillData.appointeeDetails.appointeeArray.forEach(item => {
        console.log("ffff", item)
        if(item.dob){
          let spltDob = item.dob.split("/");
          item.dob = spltDob[2]+"-"+spltDob[1]+"-"+spltDob[0];
          console.log("ffff", item.dob)
        }
      })
      this.geAppointeeArray.setValue(autoFillData.appointeeDetails.appointeeArray);
    }
  }

  // showTheNominee() {
  //   this.showNominee2 = true;
  //   this.hideNomineRemoveBtn = true;
  //   this.hideNomineAddbtn = false;
  // }
  // showRemoveNominee() {
  //   this.showNominee2 = false;
  //   this.hideNomineRemoveBtn = false;
  //   this.hideNomineAddbtn = true;
  // }

  //Ckyc Form Submission
  ckycCallFunction() {
    let reqObj = {
      "appNo": this.appBasicReqData.appno,
      "ckycNo": null,
      "fatherNmTitle": this.ckycForm.get("fatherCkycDetails").value,
      "fatherFirstNm": this.ckycForm.get("ckyc_fatherFrstNm").value,
      "fatherMiddleNm": this.ckycForm.get("ckyc_fatherMiddleNm").value,
      "fatherLastNm": this.ckycForm.get("ckyc_fatherLastNm").value,
      "motherNmTitle": this.ckycForm.get("motherCkycDetails").value,
      "motherFirstNm": this.ckycForm.get("ckyc_motherFirstNm").value,
      "motherMiddleNm": this.ckycForm.get("ckyc_motherMiddleNm").value,
      "motherLastNm": this.ckycForm.get("ckyc_motherLastNm").value,
      "maritalStatus": this.ckycForm.get("ckyc_mrtlSts").value,
      "spouseNmTitle": this.ckycForm.get("spouseCkycDetails").value,
      "spouseFirstNm": this.ckycForm.get("ckyc_SpouseFirstNm").value,
      "spouseMiddleNm": this.ckycForm.get("ckyc_SpouseMiddleNm").value,
      "spouseLastNm": this.ckycForm.get("ckyc_SpouseLastNm").value,
      "occupationType": this.ckycForm.get("ckyc_Occupation").value,
      "occupationCategory": this.ckycForm.get("ckyc_OccupCategory").value,
      "countryOfBirth": this.ckycForm.get("ckyc_CountryBirth").value
    }
    console.log(reqObj)
    this.apiService.postHdfcCkyc(reqObj).subscribe(res => { 
      if (res.status === 'OK' && res.data === "Success") {
        // this.showHdfcCkyc = false;
        // !this.ckycForm.valid;
        this.strg.setStoreData("hdfcCkycFormData", this.ckycForm.value);
        this.strg.getStoreData("hdfcRedirectUrl").then(ress=>{
          console.log("hdfc redirect url", ress)
          window.open(ress, "_blank");
        })
      }
      // console.log(this.ckycForm.valid)
    });
  }

  //Life Assured Submission Form
  submitLifeAssuredDetailsForm() {
    if (this.hdfcLifeAssuredDetailsForm.valid) {
      this.showNominee = true;
      this.showLifeAssured = false;
      this.lifeAssuredFilled = "section-btn"
      this.nominee = "section-btn active-section-btn";
    }
    let data = {
      lifeAssuredDetails: this.hdfcLifeAssuredDetailsForm.value
    }
    this.saveIncompleteAppData(data);
    this.strg.setStoreData("incp", true);
    this.validateAppointee();
    console.log("ffff", this.appointeeDetailsForm.value);
  }

  saveIncompleteAppData(data) {
    let dataIncomplete = {
      "orderId": this.applicationOrderId,
      "applicationData": data
    }

    this.apiService.saveIncompleteICICIAppData(dataIncomplete).subscribe(res => {
      console.log("save incomplete app data res", res);
    }, err => {
      console.log("save incomplete error", err)
    });
  }

  isPermanentSame() {
    if (this.hdfcLifeAssuredDetailsForm.get('hdfc_ipsaca').value === true) {
      this.sameCurrentAddr = false;
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pHouseNo').setValidators(Validators.required),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pStreet').setValidators(Validators.required),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCity').setValidators(Validators.required),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pState').setValidators(Validators.required),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_plandMark').setValidators(Validators.required),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pPincode').setValidators(Validators.required),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCountry').setValidators(Validators.required)
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pHouseNo').setValue(this.hdfcLifeAssuredDetailsForm.get('hdfc_houseNo').value)
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pStreet').setValue(this.hdfcLifeAssuredDetailsForm.get('hdfc_street').value)
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCity').setValue(this.hdfcLifeAssuredDetailsForm.get('hdfc_city').value),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_plandMark').setValue(this.hdfcLifeAssuredDetailsForm.get('hdfc_landMark').value),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pState').setValue(this.hdfcLifeAssuredDetailsForm.get('hdfc_state').value)
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pPincode').setValue(this.hdfcLifeAssuredDetailsForm.get('hdfc_pinCode').value)
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCountry').setValue(this.hdfcLifeAssuredDetailsForm.get('hdfc_country').value)
    }
    else if (this.hdfcLifeAssuredDetailsForm.get('hdfc_ipsaca').value === false) {
      this.sameCurrentAddr = true;
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pHouseNo').clearValidators(),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pHouseNo').setValue("")
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pStreet').clearValidators(),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pStreet').setValue("")
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCity').clearValidators(),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCity').setValue(""),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_plandMark').clearValidators(),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_plandMark').setValue(""),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pState').clearValidators(),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pState').setValue("")
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pPincode').clearValidators(),
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pPincode').setValue("")
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCountry').clearValidators()
      this.hdfcLifeAssuredDetailsForm.get('hdfc_pCountry').setValue("")
    }
  }

  //only letter validation
  validateLettersOnly(event) {
    console.log("target", event);
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  backtoLifeAssured() {
    this.showLifeAssured = true;
    this.showNominee = false;
    this.showAppointeeForm = false;
    this.lifeAssuredFilled = "section-btn active-section-btn";
    this.nominee = "section-btn";
    this.appointee = "section-btn"
  }
  
  backtoNominee() {
    this.showLifeAssured = false;
    this.showNominee = true;
    this.showAppointeeForm = false;
    this.lifeAssuredFilled = "section-btn";
    this.nominee = "section-btn active-section-btn";
    this.appointee = "section-btn"
  }

  //only Number Validation
  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }
  
  submitNomineeDetailsForm() {
    let sharePer = 0;
    this.getNomineeArray.value.forEach(ele => { sharePer += Number(ele.entitlePercentage) });
    if(sharePer != 100){
      this.toast.showToast("Entitlement Percentage should be 100 in total")
    } else{
      let data = {
        lifeAssuredDetails: this.hdfcLifeAssuredDetailsForm.value,
        nomineeDetails: this.nomineDetailForm.value
      }
      this.saveIncompleteAppData(data)

      let nomineeData = this.getNomineeArray.value;

      this.appObj = {
        "quoteId": this.appBasicReqData.quoteid,
        "orderId": Number(this.appBasicReqData.orderId),
        "quotedt":this.appBasicReqData.quotedt,
        "applicationNumber":this.appBasicReqData.appno,
        "appMode": this.appBasicReqData.appmode,
        "insuranceObjective": this.appBasicReqData.insobjectv,
        "payoutNeftFlag": this.appBasicReqData.payoutNeftFlag,
        "proposalReceivedDate": this._datePipe.transform(new Date(), 'dd/MM/yyyy'),
        "prodCode": this.appBasicReqData.prodCode,
        "paymentFreq": this.appBasicReqData.paymentFreq,
        "premiumAmt": this.appBasicReqData.totPremium,
        "magNumBenefit": this.appBasicReqData.magNumBenefit,
        "title": this.hdfcLifeAssuredDetailsForm.get('hdfc_title').value,
        "firstName": this.hdfcLifeAssuredDetailsForm.get('hdfc_fName').value,
        "lastName": this.hdfcLifeAssuredDetailsForm.get('hdfc_lName').value,
        "gender": this.hdfcLifeAssuredDetailsForm.get('hdfc_gender').value,
        "dateOfBirth": this._datePipe.transform(this.hdfcLifeAssuredDetailsForm.get('hdfc_dob').value, 'dd/MM/yyyy'),
        "fatherName": this.hdfcLifeAssuredDetailsForm.get('hdfc_fatherName').value,
        "maritalstatus": this.hdfcLifeAssuredDetailsForm.get('hdfc_MartlStus').value,
        "spouseName": this.hdfcLifeAssuredDetailsForm.get('hdfc_spouseNm').value,
        "educationalQualification": this.hdfcLifeAssuredDetailsForm.get('hdfc_eduQual').value,
        "natureOfOccu":this.hdfcLifeAssuredDetailsForm.get('hdfc_occList').value,
        "employerName":this.hdfcLifeAssuredDetailsForm.get('hdfc_empName').value,
        "currentAddress": {
          "houseno": this.hdfcLifeAssuredDetailsForm.get('hdfc_houseNo').value,
          "street": this.hdfcLifeAssuredDetailsForm.get('hdfc_street').value,
          "landmark": this.hdfcLifeAssuredDetailsForm.get('hdfc_landMark').value,
          "city": this.hdfcLifeAssuredDetailsForm.get('hdfc_city').value,
          "state": this.hdfcLifeAssuredDetailsForm.get('hdfc_state').value,
          "pincode": this.hdfcLifeAssuredDetailsForm.get('hdfc_pinCode').value,
          "country": this.hdfcLifeAssuredDetailsForm.get('hdfc_country').value,
        },
        "permanentAddress": {
          "houseno": this.hdfcLifeAssuredDetailsForm.get('hdfc_pHouseNo').value,
          "street": this.hdfcLifeAssuredDetailsForm.get('hdfc_pStreet').value,
          "landmark": this.hdfcLifeAssuredDetailsForm.get('hdfc_plandMark').value,
          "city": this.hdfcLifeAssuredDetailsForm.get('hdfc_pCity').value,
          "state": this.hdfcLifeAssuredDetailsForm.get('hdfc_pState').value,
          "pincode": this.hdfcLifeAssuredDetailsForm.get('hdfc_pPincode').value,
          "country": this.hdfcLifeAssuredDetailsForm.get('hdfc_pCountry').value
        },
        "nationality": this.hdfcLifeAssuredDetailsForm.get('hdfc_nationality').value,
        "residentstatus": this.hdfcLifeAssuredDetailsForm.get('hdfc_resisStatus').value,
        "birthplace": this.hdfcLifeAssuredDetailsForm.get('hdfc_birthPlace').value,
        "historyofconviction": this.hdfcLifeAssuredDetailsForm.get('hdfc_ayConvict').value === false ? "N" : "Y",
        "nriflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_nriFlg').value === false ? "N" : "Y",
        "ishdfcempflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_hdfcEmp').value === false ? "N" : "Y",
        "exstngcustflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_existCustomer').value === false ? "N" : "Y",
        "isdisabledflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_phyDisabled').value === false ? "N" : "Y",
        "pepflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_pepFlag').value === false ? "N" : "Y",
        "dematflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_dmatFlag').value === false ? "N" : "Y",
        "einsAccntNo": this.hdfcLifeAssuredDetailsForm.get('hdfc_eiaAccNo').value,
        "smokerstatusflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_aySmoker').value === false ? "N" : "Y",
        "countrycode": this.appBasicReqData.countrycode,
        "contactNumber": this.hdfcLifeAssuredDetailsForm.get('hdfc_contNumber').value,
        "contactEmail": this.hdfcLifeAssuredDetailsForm.get('hdfc_email').value,
        "expdurofstay": this.appBasicReqData.expdurofstay,
        "preferredCommAddr": this.appBasicReqData.preferredCommAddr,
        "preferredCommMode": this.appBasicReqData.preferredCommMode,
        "preferredCommLang": this.appBasicReqData.preferredCommLang,
        "occupationType": this.hdfcLifeAssuredDetailsForm.get('hdfc_occType').value,
        "industype": this.hdfcLifeAssuredDetailsForm.get('hdfc_indusType').value,
        "annualIncome": this.hdfcLifeAssuredDetailsForm.get('hdfc_annIncome').value,
        "sourceOfFundType": this.hdfcLifeAssuredDetailsForm.get('hdfc_sourceType').value,
        "fundPcntgContribution": this.hdfcLifeAssuredDetailsForm.get('hdfc_fundPercentage').value,
        "nomineeAndAppointee": nomineeData,
        "planOption": this.appBasicReqData.productPlanOption,
        "riderDetails": this.riderDetails
      }
  
      //todo: appsubmit / appointee
      if(this.showAppointee){
        this.showLifeAssured = false;
        this.showNominee = false;
        this.showAppointeeForm = true;
        this.lifeAssuredFilled = "section-btn";
        this.nominee = "section-btn";
        this.appointee = "section-btn active-section-btn"
        this.validateAppointee();
      } else{
        this.submitHdfcApplication()
      }
    }
    console.log("ffff", this.appointeeDetailsForm.value);
  }

  submitAppointeeDetailsForm(){
    console.log("ffff", this.appointeeDetailsForm.value, this.geAppointeeArray.value);
    let data = {
      lifeAssuredDetails: this.hdfcLifeAssuredDetailsForm.value,
      nomineeDetails: this.nomineDetailForm.value,
      appointeeDetails: this.appointeeDetailsForm.value
    }
    this.saveIncompleteAppData(data)
    setTimeout(()=>{
      console.log("this.geAppointeeArray.value", this.geAppointeeArray.value);
      this.geAppointeeArray.value.forEach(element => {
        this.appObj.nomineeAndAppointee.push(element);
      });
      console.log("main req obj", this.appObj);
      this.submitHdfcApplication();
    },1000)
  }

  submitHdfcApplication(){
    // this.appObj = {
    //   "quoteId": this.appBasicReqData.quoteid,
    //   "orderId": Number(this.appBasicReqData.orderId),
    //   "quotedt":this.appBasicReqData.quotedt,
    //   "appnum":this.appBasicReqData.appno,
    //   "appMode": "APP_MODE_ASST",
    //   "insuranceObjective": "IOBJ_PROTN_CD",
    //   "payoutNeftFlag": "N",
    //   "proposalReceivedDate": this._datePipe.transform(new Date(), 'dd/MM/yyyy'),
    //   "prodCode": "P1C2PLE",
    //   "paymentFreq": this.appBasicReqData.paymentFreq,
    //   "premiumAmt": this.appBasicReqData.totPremium,
    //   "magNumBenefit": "Life",
    //   "title": this.hdfcLifeAssuredDetailsForm.get('hdfc_title').value,
    //   "firstName": this.hdfcLifeAssuredDetailsForm.get('hdfc_fName').value,
    //   "lastName": this.hdfcLifeAssuredDetailsForm.get('hdfc_lName').value,
    //   "gender": this.hdfcLifeAssuredDetailsForm.get('hdfc_gender').value,
    //   "dateOfBirth": this._datePipe.transform(this.hdfcLifeAssuredDetailsForm.get('hdfc_dob').value, 'dd/MM/yyyy'),
    //   "fatherName": this.hdfcLifeAssuredDetailsForm.get('hdfc_fatherName').value,
    //   "maritalstatus": this.hdfcLifeAssuredDetailsForm.get('hdfc_MartlStus').value,
    //   "educationalQualification": this.hdfcLifeAssuredDetailsForm.get('hdfc_eduQual').value,
    //   "natureOfOccu":this.hdfcLifeAssuredDetailsForm.get('hdfc_occList').value,
    //   "employerName":this.hdfcLifeAssuredDetailsForm.get('hdfc_empName').value,
    //   "currentAddress": {
    //     "houseno": this.hdfcLifeAssuredDetailsForm.get('hdfc_houseNo').value,
    //     "street": this.hdfcLifeAssuredDetailsForm.get('hdfc_street').value,
    //     "landmark": this.hdfcLifeAssuredDetailsForm.get('hdfc_landMark').value,
    //     "city": this.hdfcLifeAssuredDetailsForm.get('hdfc_city').value,
    //     "state": this.hdfcLifeAssuredDetailsForm.get('hdfc_state').value,
    //     "pincode": this.hdfcLifeAssuredDetailsForm.get('hdfc_pinCode').value,
    //     "country": this.hdfcLifeAssuredDetailsForm.get('hdfc_country').value,
    //   },
    //   "permanentAddress": {
    //     "houseno": this.hdfcLifeAssuredDetailsForm.get('hdfc_pHouseNo').value,
    //     "street": this.hdfcLifeAssuredDetailsForm.get('hdfc_pStreet').value,
    //     "landmark": this.hdfcLifeAssuredDetailsForm.get('hdfc_plandMark').value,
    //     "city": this.hdfcLifeAssuredDetailsForm.get('hdfc_pCity').value,
    //     "state": this.hdfcLifeAssuredDetailsForm.get('hdfc_pState').value,
    //     "pincode": this.hdfcLifeAssuredDetailsForm.get('hdfc_pPincode').value,
    //     "country": this.hdfcLifeAssuredDetailsForm.get('hdfc_pCountry').value
    //   },
    //   "nationality": this.hdfcLifeAssuredDetailsForm.get('hdfc_nationality').value,
    //   "residentstatus": this.hdfcLifeAssuredDetailsForm.get('hdfc_resisStatus').value,
    //   "birthplace": this.hdfcLifeAssuredDetailsForm.get('hdfc_birthPlace').value,
    //   "historyofconviction": this.hdfcLifeAssuredDetailsForm.get('hdfc_ayConvict').value === false ? "N" : "Y",
    //   "nriflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_nriFlg').value === false ? "N" : "Y",
    //   "ishdfcempflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_hdfcEmp').value === false ? "N" : "Y",
    //   "exstngcustflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_existCustomer').value === false ? "N" : "Y",
    //   "isdisabledflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_phyDisabled').value === false ? "N" : "Y",
    //   "pepflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_pepFlag').value === false ? "N" : "Y",
    //   "dematflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_dmatFlag').value === false ? "N" : "Y",
    //   "smokerstatusflg": this.hdfcLifeAssuredDetailsForm.get('hdfc_aySmoker').value === false ? "N" : "Y",
    //   "countrycode": "91",
    //   "contactNumber": this.hdfcLifeAssuredDetailsForm.get('hdfc_contNumber').value,
    //   "contactEmail": this.hdfcLifeAssuredDetailsForm.get('hdfc_email').value,
    //   "expdurofstay": "MTH1YR",
    //   "preferredCommAddr": "ADD_CORSP",
    //   "preferredCommMode": "CALL",
    //   "preferredCommLang": "LANG_ENG",
    //   "occupationType": this.hdfcLifeAssuredDetailsForm.get('hdfc_occType').value,
    //   "annualIncome": this.hdfcLifeAssuredDetailsForm.get('hdfc_annIncome').value,
    //   "sourceOfFundType": this.hdfcLifeAssuredDetailsForm.get('hdfc_sourceType').value,
    //   "fundPcntgContribution": this.hdfcLifeAssuredDetailsForm.get('hdfc_fundPercentage').value,
    //   "nomineeAndAppointee": this.getNomineeArray.value,
    // }
    this.appObj.nomineeAndAppointee.forEach(item => {
      console.log("ffff", item)
      if(item.dob){
        item.dob = this._datePipe.transform(item.dob, "dd/MM/yyyy");
        console.log("ffff", item.dob)
      }
    })
    console.log("post hdfc app req obj", this.appObj)
    this.loader.showLoader();
    this.apiService.postHdfcApp(this.appObj).subscribe(res => {
      this.loader.hideLoader();
      console.log(res)
      if(res.status === "OK" && res.data.status === "Success"){
        this.strg.setStoreData("hdfcRedirectUrl", res.data.redirectUrl);
        this.strg.setStoreData("hdfcBasicReqData",this.appBasicReqData);
        this.showHdfcCkyc = true;
      }
    }, err => {
      this.loader.hideLoader();
      console.log("err", err);
    })
  }

  ifMarried(event) {
    if(event === "MAR_MRD") {
      this.showSpouseField = true;
      this.ckycForm.get("spouseCkycDetails").setValidators(Validators.required);
      this.ckycForm.get("ckyc_SpouseFirstNm").setValidators(Validators.required);
      this.ckycForm.get("ckyc_SpouseLastNm").setValidators(Validators.required);
    }
    else {
      this.showSpouseField = false;
      this.ckycForm.get("spouseCkycDetails").setValue(null);
      this.ckycForm.get("ckyc_SpouseFirstNm").setValue("");
      this.ckycForm.get("ckyc_SpouseLastNm").setValue("");
      this.ckycForm.get("spouseCkycDetails").clearValidators();
      this.ckycForm.get("ckyc_SpouseFirstNm").clearValidators();
      this.ckycForm.get("ckyc_SpouseLastNm").clearValidators();
    }
  }

  getQuoteResId() {
    let dataa = {
      "productName": "HDFC Life Click 2 Protect Life",
      "latest": true
    }

    this.apiService.getQuotesByUserId(dataa).subscribe(res => {
      console.log("get quote res", res);
      //let quoteHdfc = res.data.filter(item => item.insuranceQuoteRequest.insuranceProductDetails.name === "HDFC Life Click 2 Protect Life")
      //console.log(quoteHdfc)
      // let quoteRes = res.data[res.data.length - 1];

      let quoteRes = res.data.pop();
      console.log(quoteRes)
      console.log(JSON.parse(quoteRes.insuranceQuoteRequest.reqParam), '0000')
      let quoteResParam = JSON.parse(quoteRes.responseParam);
      let quoteReqParam= JSON.parse(quoteRes.insuranceQuoteRequest.reqParam)
      this.upgradedQuoteReqObj = quoteReqParam;
      this.upgradedQuoteResponseObj = quoteResParam;
      this.autoFillBasicData();
      console.log("fffff", this.upgradedQuoteReqObj, quoteRes.id);
      this.appBasicReqData.quoteid = quoteRes.id;
      // this.appBasicReqData.quoteid = quoteRes.quoteid;
      this.appBasicReqData.appno = quoteResParam.appnum;
      this.appBasicReqData.quotedt = this._datePipe.transform(quoteResParam.qtDt, "dd/MM/yyyy");
      this.appBasicReqData.totPremium = quoteResParam.totPremium;
      this.appBasicReqData.paymentFreq = quoteReqParam.freq;
      // this.appBasicReqData.prodCode=quoteResParam.prodCode; //commented prodCode for static value

      this.createProductPlanOption();

      // this.appBasicReqData.appmode=quoteResParam.appMode; //commented appmode for static value
      //this.appBasicReqData.orderId=quoteRes.id
      let data = {
        "quoteResponseId": quoteRes.id
      }
      this.apiService.getApplicationOrderId(data).subscribe(res => {
        console.log(res, 'quote order response')
        this.appBasicReqData.orderId = res.data.id;
        this.applicationOrderId = res.data.id;
        console.log(res.data.id)
        console.log((res.data.orderNumber), "8888888")
      })
      // let quoteRes = res.data.filter(item => item.insuranceQuoteRequest.insuranceProductDetails.name === "ICICI Pru iProtect Smart");
      // this.reqExtData.quoteResponseId = quoteRes[0].id;
      //this.reqExtData.quoteResponseId = quoteRes.id;
    })
  }

  dobValidate(event, nomineeNo) {
    console.log("eevntttt",event, nomineeNo);
    if(event != ""){
      const qt_dob: string = event;
      const today = new Date();
      let dobInput = new Date(qt_dob);
      let age = today.getFullYear() - dobInput.getFullYear();
      const m = today.getMonth() - dobInput.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dobInput.getDate())) {
        age--;
      }
      if (age >= 18) {
        console.log('Major')
        if(this.nomineeMinorArray.includes('nominee' + nomineeNo)){
          const index = this.nomineeMinorArray.indexOf('nominee' + nomineeNo);
          this.nomineeMinorArray.splice(index, 1);
        }
        console.log("nomineeearray", this.nomineeMinorArray);
      } else {
        console.log('Minor')
        if(!this.nomineeMinorArray.includes('nominee' + nomineeNo)){
          console.log("not present!")
          this.nomineeMinorArray.push('nominee' + nomineeNo);
        }
        console.log("nomineeearray", this.nomineeMinorArray);
      }
      this.validateAppointee();
    }
  }

  nomineeMinorArray = [];
  showAppointeeForm: boolean = false;

  validateAppointee(){
    console.log("valiiiii", this.nomineeMinorArray);
    if(this.nomineeMinorArray.length > 0){
      this.showAppointee = true;
      if(this.nomineeMinorArray.length == 2){
        if(this.geAppointeeArray.length < 2){
          this.addAppointee();
        }
        // while (this.geAppointeeArray.length !== 0) {
        //   this.geAppointeeArray.removeAt(0)
        // }
        // this.nomineeMinorArray.forEach(element => {
        //   this.addAppointee();
        // });
        this.setRelatedParty(0, "NOMINEE_0");
        // if(this.nomineeMinorArray.length == 2)
          this.setRelatedParty(1, "NOMINEE_1");
      } else {
        this.removeAppointee(1);
        this.nomineeMinorArray.forEach(item => {
          if(item === "nominee1"){
            this.setRelatedParty(0, "NOMINEE_0");
          } else{
            this.setRelatedParty(0, "NOMINEE_1");
          }
        });
      }
    } else {
      this.showAppointee = false;
    }
  }

  setRelatedParty(index, val){
    // const myForm = (<FormArray>this.appointeeDetailsForm.get("appointeeArray")).at(index).patchValue({relatedParty: val});
    const myForm = (<FormArray>this.appointeeDetailsForm.get("appointeeArray")).at(index);
    console.log("Before=>", myForm.value, myForm.value.relatedParty);
    myForm.patchValue({
      relatedParty: val
    });
    this.appointeeDetailsForm.updateValueAndValidity();
    console.log("=>", myForm.value, myForm.value.relatedParty);
    console.log("ffff", this.appointeeDetailsForm.value);
  }

  backtoupgrade() {
    this.router.navigate(['/quote-upgrade']);
  }

  autoFillBasicData(){
    this.hdfcLifeAssuredDetailsForm.get("hdfc_fName").setValue(this.upgradedQuoteReqObj.firstName);
    this.hdfcLifeAssuredDetailsForm.get("hdfc_lName").setValue(this.upgradedQuoteReqObj.lastName);
    this.hdfcLifeAssuredDetailsForm.get("hdfc_gender").setValue(this.upgradedQuoteReqObj.gender);
    console.log("fgggggg", this.upgradedQuoteReqObj.dateOfBirth);
    let spltDate = this.upgradedQuoteReqObj.dateOfBirth.split('/');
    this.hdfcLifeAssuredDetailsForm.get("hdfc_dob").setValue(spltDate[2]+'-'+spltDate[1]+'-'+spltDate[0]);
    this.hdfcLifeAssuredDetailsForm.get("hdfc_aySmoker").setValue(this.upgradedQuoteReqObj.tobaccoStatus === "N" ? false : true);
    this.hdfcLifeAssuredDetailsForm.get("hdfc_email").setValue(this.upgradedQuoteReqObj.email);
    this.hdfcLifeAssuredDetailsForm.get("hdfc_contNumber").setValue(this.quoteFormReqObj.qt_mobileNo);
    this.hdfcLifeAssuredDetailsForm.get("hdfc_annIncome").setValue(this.quoteFormReqObj.qt_annualIncome);
    this.hdfcLifeAssuredDetailsForm.get("hdfc_eduQual").setValue(this.quoteFormReqObj.qt_eduQualification);
  }

  entitlementPercentChanged(){
    let sharePer = 0;
    this.getNomineeArray.value.forEach(ele => { sharePer += Number(ele.entitlePercentage) });
    if(sharePer >= 100){
      this.disableAddNomineeBtn = true;
    }else {
      this.disableAddNomineeBtn = false;
    }
  }

}
